module.exports = __webpack_public_path__ + "img/nav-header-mobile-jewelry.ff4b126.webp";